/**
 * Treemap label tier from RENDERED size (F4, plan §3.3 · §4.5).
 *
 * Four tiers, because the treemap has to stay readable from a full-bleed
 * Technology tile down to a sliver of Real Estate. The thresholds are in
 * RENDERED PIXELS, not percentages: the reference multiplies its percentage
 * height by the treemap's own pixel height before comparing (demo line 870), and
 * a percentage threshold would change meaning with the viewport.
 *
 * Tier 3 additionally requires WIDTH, because the tier-3 meta line
 * ("$14.0T · 22/29 ADV · VOL 27%") wraps illegibly in a tall narrow column —
 * height alone is not enough to earn it.
 *
 *   3 — name + return + meta line
 *   2 — name + return, larger type
 *   1 — name + return
 *   0 — name only
 */
export const LABEL_TIER_MIN_HEIGHT_PX = Object.freeze({ 1: 34, 2: 58, 3: 100 });
/**
 * Tier-3 width threshold. Despite the MIN name, the comparison is STRICT
 * (`widthPct > …`): the Phase 0 demo and `layout.test.ts` pin exclusive
 * behaviour so a tile at exactly 15% stays tier 2. Renaming would break the
 * exported constant; the exclusive comparison is the load-bearing contract.
 */
export const LABEL_TIER_3_MIN_WIDTH_PCT = 15;

export type LabelTier = 0 | 1 | 2 | 3;

export function labelTier(heightPx: number, widthPct: number): LabelTier {
  if (heightPx >= LABEL_TIER_MIN_HEIGHT_PX[3] && widthPct > LABEL_TIER_3_MIN_WIDTH_PCT) return 3;
  if (heightPx >= LABEL_TIER_MIN_HEIGHT_PX[2]) return 2;
  if (heightPx >= LABEL_TIER_MIN_HEIGHT_PX[1]) return 1;
  return 0;
}
